import { DealRequest } from "@/app/api/types";
import { useAppSelector } from "@/app/hooks";
import { ClarificationModalRef } from "@/features/factor-request-clarification-modal/types";
import { Box, Button, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  data: DealRequest["clarifications"][0];
  openClarificationModal?: ClarificationModalRef["open"];
  type?: "comment" | "answer";
}

export const ClarificationItem: FC<Props> = ({
  data,
  openClarificationModal,
  type = "comment",
}) => {
  const { t } = useTranslation();
  const { cabinetType } = useAppSelector((state) => state.auth);

  const isCommentHasAnswer = !!data?.answer;
  const isComment = type === "comment";

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          p: 2,
          borderRadius: "6px",
          bgcolor: isComment
            ? "rgba(255, 220, 102, 0.1)"
            : "rgba(76, 172, 17, 0.1)",
          position: "relative",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Box>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              {isComment ? t("factor") : t("supplier")}:{" "}
              <Box
                component="span"
                sx={{
                  fontWeight: 400,
                  textTransform: "lowercase",
                  color: "rgba(11, 19, 112, .5)",
                }}
              >
                {t("from_value", {
                  date: isComment ? data.askedAt : data.answeredAt,
                })}
              </Box>
            </Typography>

            <Typography>{isComment ? data.comment : data.answer}</Typography>
          </Box>
          {cabinetType === "sellerOrBuyer" && isComment && (
            <Button
              color="secondary"
              onClick={() => {
                openClarificationModal?.(data.unique);
              }}
            >
              {t("to_answer")}
            </Button>
          )}
        </Stack>
      </Box>

      {isCommentHasAnswer && (
        <Box
          sx={{
            p: 2,
            borderRadius: "6px",
            bgcolor: "rgba(76, 172, 17, 0.1)",
            position: "relative",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="space-between"
          >
            <Box>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                {t("supplier")}:{" "}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 400,
                    textTransform: "lowercase",
                    color: "rgba(11, 19, 112, .5)",
                  }}
                >
                  {t("from_value", {
                    date: data.answeredAt,
                  })}
                </Box>
              </Typography>

              <Typography>{data.answer}</Typography>
            </Box>
          </Stack>
        </Box>
      )}
    </Stack>
  );
};
